import React from 'react';

/**
 * LoadingSpinner Component
 * A lightweight, CSS-only spinner that matches Faraja Media's gold branding.
 * Ideal for diaspora users on slow connections.
 */
interface LoadingSpinnerProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  message = "Loading...", 
  size = 'md' 
}) => {
  const sizeClasses = {
    sm: 'w-5 h-5 border-2',
    md: 'w-10 h-10 border-4',
    lg: 'w-16 h-16 border-8'
  };

  return (
    <div className="flex flex-col items-center justify-center p-8">
      <div 
        className={`${sizeClasses[size]} border-white/10 rounded-full animate-spin`}
        style={{ borderTopColor: '#D4AF37' }} // Faraja Gold
      />
      {message && (
        <p className="mt-4 text-[10px] uppercase tracking-[0.3em] text-white/40 font-bold animate-pulse">
          {message}
        </p>
      )}
    </div>
  );
};

export default LoadingSpinner;